module.exports = __webpack_public_path__ + "img/V23.986ddb37.jpg";